import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {IReview} from "../../review/interface/review";
import {ReviewTransmissionService} from "../../raintree/transmission/review-transmission.service";
import {IReviewProductPreview} from "../../review/interface/review-product-preview";
import {LightgalleryModule} from "lightgallery/angular";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import {LightGallery} from "lightgallery/lightgallery";
import {LightGalleryItem} from "../interface/light-gallery-item";

@Component({
	selector: 'fb-product-review-section',
	standalone: true,
	imports: [CommonModule, LightgalleryModule],
	templateUrl: './product-review-section.component.html',
	styleUrls: ['./product-review-section.component.scss']
})
export class ProductReviewSectionComponent {

	@Input()
	public reviewCount: number = 0;
	@Input()
	public rating: number = 0;
	@Input()
	public productId: number = 0;

	protected stars: boolean[] = Array(5).fill(0);
	private pageNumber: number = 0;
	private pageSize: number = 10;
	protected loading: boolean = false;
	protected reviewList: IReview[] = [];
	public lightGallery!: LightGallery;
	public galleryItems: LightGalleryItem[] = [];

	constructor(
		private _api: ReviewTransmissionService
	) {
	}

	ngOnInit(): void {
		this.resolveReviews();
	}

	private resolveReviews() {
		this.productId === 0 ? this.resolveAllReviewList() : this.resolveProductSpecificReviewList();
	}

	private prepareProductImages(imagesCSV: string, productName: string): LightGalleryItem[] {
		return imagesCSV.split(",").map(image => {
			return  {
				src: image,
				type: 'image',
				thumb: image,
				alt: productName,
				subHtml: '<h4>' + productName + '</h4>',
			}
		})
	}

	private resolveProductSpecificReviewList(): void {
		this._api.getProductSpecificReviewList(
			this.productId,
			this.pageNumber,
			5,
			() => {
				this.loading = true
			},
			(response: IReview[]) => {
			},
			(response: IReview[]) => {
				this.reviewList = response;
				this.loading = false;
			},
			(error: string) => {
			},
			() => {
			}
		)
	}

	private resolveAllReviewList(): void {
		this._api.getReviewList(
			this.pageNumber,
			this.pageSize,
			() => {
				this.loading = true;
			},
			(response: IReview[]) => {
			},
			(response: IReview[]) => {
				this.reviewList = [...this.reviewList, ...response];
				this.loading = false;
			},
			(error: string) => {
			},
			() => {
			}
		)
	}

	public onUserProvidedImagesClick(review: IReview) {
		if(review.productImages) {
			this.galleryItems = this.prepareProductImages(review.productImages, review.product? review.product.name : review.name);
			this.lightGallery?.refresh(this.galleryItems);
			this.lightGallery?.openGallery(0);
		}
	}

	protected prepareProductRedirectionUrl(product: IReviewProductPreview | undefined): string {
		if (!product) return '#';

		return (product.productGroup == 'fabric' || product.productGroup == 'swatch')
			? `/product/fabric-product/${product.slug}`
			: `/product/finished-product/${product.slug}`;
	}

	public settings = {
		dynamic: true,
		dynamicEl: this.galleryItems,
		download: false,
		counter: true,
		enableSwipe: true,
		height: '100%',
		plugins: [lgThumbnail, lgZoom]
	};

	public onInit = (detail: any): void => {
		this.lightGallery = detail.instance;
	};
}
